import { createSvgIcon } from '@mui/material/utils';

/**
 * Same as KeyboardTabRounded (tab arrow pointing right) but mirrored to the left.
 * Built with MUI createSvgIcon; path is flipped horizontally around the 24x24 viewBox center.
 */
const keyboardTabRoundedPath = (
  <path d="M12.29 8.12 15.17 11H2c-.55 0-1 .45-1 1s.45 1 1 1h13.17l-2.88 2.88c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L13.7 6.7a.996.996 0 0 0-1.41 0c-.38.39-.39 1.03 0 1.42M20 7v10c0 .55.45 1 1 1s1-.45 1-1V7c0-.55-.45-1-1-1s-1 .45-1 1" />
);

export const KeyboardTabRoundedLeftIcon = createSvgIcon(
  <g transform="translate(12,12) scale(-1,1) translate(-12,-12)">{keyboardTabRoundedPath}</g>,
  'KeyboardTabRoundedLeft',
);
